import { useLocation, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { authService } from '../../../utils/authService';
import { Table, Button, Form, Modal, Spinner } from "react-bootstrap";
import { fetchAllCourses } from "../../../utils/courseUtils";
import { fetchBatchesByCourseSingle } from "../../../utils/batchUtils";
import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { PiSortDescendingLight, PiSortAscendingLight } from "react-icons/pi";
import { HiOutlineDotsVertical } from "react-icons/hi";
interface Course {
  course_id: string;
  course_name: string;
}

interface StudentData {
  student_id?: string;
  course_id: string;
  batch_id: string;
  student_firstname: string;
  student_lastname: string;
  student_email: string;
  student_gender: string;
  student_country: string;
  student_state: string;
  student_city: string;
  student_dob: string;
  college: string;
  branch: string;
  address: string;
  student_pincode: string;
  phone: string;
  student_alt_phone: string;
  student_type: string;
  isActive: boolean;
  student_qualification: string;
  allocate: boolean;
}

interface Batch {
  batch_name: string;
  batch_id: string;
  max_no_of_students:number;
  students_count:number;
}

interface College {
  college_id: string;
  college_name: string;
  center_name: string;
  college_code: string;
  branches: Branch[];
}

interface Branch {
  branch_id: string;
  branch_name: string;
}

const Student: React.FC = () => {
  const location = useLocation();
  const batchId = location.state?.batch_id ? location.state.batch_id : "";
  const batchName = location.state?.batch_name ? location.state.batch_name : "";
  const courseId = location.state?.course_id ? location.state.course_id : "";
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false);
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchError, setSearchError] = useState<string>("");
  const [loadingSearchStudent, setLoadingSearchStudent] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("new");
  const [loadingCourses, setLoadingCourses] = useState<boolean>(false);
  const [loadingColleges, setLoadingColleges] = useState<boolean>(false);
  const [loadingBatches, setLoadingBatches] = useState<boolean>(false);
  const [loadingStudents, setLoadingStudents] = useState<boolean>(false);
  const [loadingEmailCheck, setLoadingEmailCheck] = useState<boolean>(false);
  const [loadingSaveStudent, setLoadingSaveStudent] = useState<boolean>(false);
  const [loadingDeleteStudent, setLoadingDeleteStudent] = useState<boolean>(false);
  const [loadingAllocateStudent, setLoadingAllocateStudent] = useState<boolean>(false);
  const [loadingFileUpload, setLoadingFileUpload] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [students, setStudents] = useState<StudentData[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedStudent, setSelectedStudent] = useState<StudentData | null>(null);
  const [courses, setCourses] = useState<Course[]>([]);
  const [selectedCourse, setSelectedCourse] = useState(courseId);
  const [selectedBatch, setSelectedBatch] = useState(batchId);
  const [batches, setBatches] = useState<Batch[]>([]);
  const [modalBatches, setModalBatches] = useState<Batch[]>([]);
  const [modalCourses, setModalCourses] = useState<Course[]>([]);
  const [colleges, setColleges] = useState<College[]>([]);
  const [selectedCollege, setSelectedCollege] = useState<string>("");
  const [branches, setBranches] = useState<Branch[]>([]);
  const [modalNewMessage, setModalNewMessage] = useState<string>("");
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [formData, setFormData] = useState<StudentData>({
    student_firstname: "",
    student_lastname: "",
    course_id: selectedCourse,
    batch_id: selectedBatch,
    student_email: "",
    student_gender: "",
    student_country: "India",
    student_state: "Karnataka",
    student_city: "",
    student_dob: "",
    college: "",
    branch: "",
    address: "",
    student_pincode: "",
    phone: "",
    student_alt_phone: "",
    student_type: "Swapnodaya",
    isActive: true,
    student_qualification: "",
    allocate: false
  });
  const [showResModal, setResShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [addStudentError, setAddStudentError] = useState<string>("");
  const [max,setMax]=useState<number>(0);
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: string }>({ key: '', direction: '' });
  const [isDeletedStudentRecord, setIsDeletedStudentRecord] = useState<boolean>(false);
  const [batchMoveNotice, setBatchMoveNotice] = useState<string>("");
  

  useEffect(() => {
    if (!batchId || !courseId || !batchName) {
      navigate("/batches");
    }
  }, [batchId, courseId]);

  useEffect(() => {
    fetchCourses();
    fetchColleges();
  }, []);

  useEffect(() => {
    if (selectedBatch !== "") {
      fetchStudents();
      setAddStudentError("")
    } else {
      setStudents([]);
      setAddStudentError("")

    }
  }, [selectedBatch]);

  useEffect(() => {
    if (selectedCourse !== "") {
      setStudents([])
      fetchBatches();
    }
  }, [selectedCourse]);

  useEffect(() => {
    if (formData.course_id !== "") {
      fetchModalBatches();
    }
  }, [formData.course_id]);

  useEffect(() => {
    if (selectedCollege !== "") {
      const college = colleges.find(college => college.college_code === selectedCollege);
      if (college) {
        setBranches(college.branches);
      }
    } else {
      setBranches([]);
    }
  }, [selectedCollege, colleges]);

  const fetchBatches = async () => {
    try {
      setLoadingBatches(true);
      const data = await fetchBatchesByCourseSingle(selectedCourse);
      setBatches(data);
    } catch (error) {
      console.error('Error fetching batches:', error);
    } finally {
      setLoadingBatches(false);
    }
  };

  const fetchModalBatches = async () => {
    try {
      setLoadingBatches(true);
      const batches = await fetchBatchesByCourseSingle(formData.course_id);
      setModalBatches(batches);
      if (batches.length > 0) {
        setFormData((prevFormData) => ({
          ...prevFormData,
        }));
      }
    } catch (error) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        batch_id: "",
      }));
      setModalBatches([]);
      console.error('Error fetching modal batches:', error);
    } finally {
      setLoadingBatches(false);
    }
  };

  const fetchCourses = async () => {
    try {
      setLoadingCourses(true);
      const data = await fetchAllCourses();
      setCourses(data);
      setModalCourses(data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    } finally {
      setLoadingCourses(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setLoadingColleges(true);
      const response = await authService.get('/admin/branch_and_college/');
      setColleges(response.data.colleges);
    } catch (error) {
      console.error('Error fetching colleges:', error);
    } finally {
      setLoadingColleges(false);
    }
  };

  const fetchStudents = async () => {
    if (selectedCourse === "" || selectedBatch === "") return;
    try {
      setLoadingStudents(true);
      const response = await authService.post("/admin/get_students_of_batch/", { batch_id: selectedBatch, course_id: selectedCourse });
      setStudents(response.data.students);
      setMax(response.data.max)
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoadingStudents(false);
    }
  };

  const handleModal = (type: string, student?: StudentData): void => {
    if (type === "new" && students.length >= max) {
        setAddStudentError(`There are already ${max} number of students in this batch. You cannot add another.`);
        return;
    }
    setAddStudentError("");
    setModalType(type);
    if (type === "new") {
      setSelectedCollege("");
      setIsDeletedStudentRecord(false);
      setShowEmailModal(true);
    } else if (student) {
        setFormData(student);
        setSelectedCollege(student.college);
        setIsDeletedStudentRecord(false);
        setShowModal(true);
    }
    setError("");
};

  const handleEmailSubmit = async () => {
    try {
      setLoadingEmailCheck(true);
      const response = await authService.post(`/admin/check_mail_and_number/`, { email });
      const studentData = response.data.data;
      setIsDeletedStudentRecord(Boolean(studentData?.del_row));
      if (studentData) {
        const targetBatch = selectedBatch || studentData.batch_id;
        setFormData({
          ...studentData,
          course_id: selectedCourse || studentData.course_id,
          batch_id: targetBatch,
        });
        setSelectedCollege(studentData.college);
        setBatchMoveNotice(
          studentData.batch_id && targetBatch && studentData.batch_id !== targetBatch
            ? "This student is already in another batch. Saving will move them to the selected batch."
            : ""
        );
        setModalType("edit");
      } else {
        setBatchMoveNotice("");
        setSelectedCollege("");
        setFormData({
          student_firstname: "",
          student_lastname: "",
          course_id: selectedCourse,
          batch_id: selectedBatch,
          student_gender: "",
          student_country: "India",
          student_state: "Karnataka",
          student_city: "",
          student_dob: "",
          college: "",
          branch: "",
          address: "",
          student_pincode: "",
          phone: "",
          student_alt_phone: "",
          student_type: "Swapnodaya",
          isActive: true,
          student_qualification: "",
          allocate: false,
          student_email: email,
        });
        setModalType("new");
      }
      setShowEmailModal(false);
      setShowModal(true);
    } catch (error) {
      setError("Error checking email");
      console.error("Error checking email:", error);
    } finally {
      setLoadingEmailCheck(false);
    }
  };

  const toDateInputValue = (value?: string | null): string => {
    if (!value) return "";
    const text = String(value);
    if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10);
    return text;
  };

  const applyStudentDetails = (studentData: StudentData & { del_row?: boolean }) => {
    setIsDeletedStudentRecord(Boolean(studentData?.del_row));
    setFormData({
      ...studentData,
      student_dob: toDateInputValue(studentData.student_dob),
      student_alt_phone: studentData.student_alt_phone || "",
      address: studentData.address || "",
      student_pincode: studentData.student_pincode || "",
      student_qualification: studentData.student_qualification || "",
      student_country: studentData.student_country || "India",
      student_state: studentData.student_state || "Karnataka",
    });
    setSelectedCollege(studentData.college || "");
    setBatchMoveNotice("");
    setModalType("edit");
    setError("");
    setShowModal(true);
  };

  const handleSearchStudent = async () => {
    const lookup = searchQuery.trim();
    if (!lookup) {
      setSearchError("Enter a student ID, email, or mobile number");
      return;
    }
    try {
      setLoadingSearchStudent(true);
      setSearchError("");
      const response = await authService.post(`/admin/search_student/`, { query: lookup });
      const studentData = response.data.data;
      if (!studentData) {
        setSearchError("No student found for that ID, email, or mobile number");
        return;
      }
      applyStudentDetails(studentData);
      setShowSearchModal(false);
    } catch (error) {
      setSearchError("Error searching student details");
      console.error("Error searching student:", error);
    } finally {
      setLoadingSearchStudent(false);
    }
  };

  const handleSave = async (): Promise<void> => {
    if (!formData.batch_id || !formData.student_firstname || !formData.student_lastname || !formData.student_gender || !formData.student_email || !formData.phone || !formData.student_dob || !formData.college || !formData.branch) {
        setError("All * marked fields are required");
        return;
    }

    // Validate phone number length
    if (formData.phone.length !== 10) {
        setError("Phone number must be exactly 10 digits");
        return;
    }

    // Validate alternate phone number if provided
    if (formData.student_alt_phone && formData.student_alt_phone.length !== 10) {
        setError("Alternate phone number must be exactly 10 digits");
        return;
    }

    const isBatchTaken = students.some(student => (student.student_email.toLowerCase() === formData.student_email.toLowerCase() && student.student_id !== formData.student_id));
    if (isBatchTaken) {
        setError("The Email you have entered is already taken");
        return;
    }
    const selectedBatchData = modalBatches.find(batch => batch.batch_id === formData.batch_id);
    const alreadyInTarget = students.some(
      (student) => student.student_id === formData.student_id && student.batch_id === formData.batch_id
    );
    if (
      selectedBatchData &&
      !alreadyInTarget &&
      selectedBatchData.students_count >= selectedBatchData.max_no_of_students
    ) {
        setError(`There are already ${selectedBatchData.students_count} students in this batch. Try adding to another batch or increase the number of students.`);
        return;
    }

    setError("");
    setLoadingSaveStudent(true);
    try {
        const savedBatch = formData.batch_id;
        const savedCourse = formData.course_id;
        const json = { ...formData };
        const response = await authService.post("/admin/create_student/", json);
        setSelectedCollege('');
        setBatchMoveNotice("");
        setShowModal(false);
        if (savedCourse && savedCourse !== selectedCourse) {
          setSelectedCourse(savedCourse);
        }
        if (savedBatch && savedBatch !== selectedBatch) {
          setSelectedBatch(savedBatch);
        } else {
          fetchStudents();
        }
        setSuccessMessage(response.data.message?response.data.message:response.data.detail);
        setShowSuccessModal(true);
    } catch (error) {
        setError("Error saving Student");
        console.error("Error saving Student:", error);
    } finally {
        setLoadingSaveStudent(false);
    }
};


  const handleDelete = (student: StudentData): void => {
    setSelectedStudent(student);
    setShowDeleteModal(true);
  };

  const confirmDelete = async (): Promise<void> => {
    if (selectedStudent) {
      try {
        setLoadingDeleteStudent(true);
        const json = {
          id: selectedStudent.student_id,
        };

        await authService.post("/admin/delete_student/", json);

        fetchStudents();
        setShowDeleteModal(false);
      } catch (error) {
        console.error("Error deleting student:", error);
      } finally {
        setLoadingDeleteStudent(false);
      }
    }
  };

    const handleSort = (key: string) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedStudents = () => {
  let filtered = [...students];

  if (sortConfig.key) {
    filtered = filtered.sort((a, b) => {
      const aValue = a[sortConfig.key as keyof StudentData];
      const bValue = b[sortConfig.key as keyof StudentData];

      // Handle cases where aValue or bValue could be undefined
      if (aValue === undefined && bValue === undefined) return 0;
      if (aValue === undefined) return sortConfig.direction === 'ascending' ? 1 : -1;
      if (bValue === undefined) return sortConfig.direction === 'ascending' ? -1 : 1;

      if (aValue === null && bValue === null) return 0;
      if (aValue === null) return sortConfig.direction === 'ascending' ? -1 : 1;
      if (bValue === null) return sortConfig.direction === 'ascending' ? 1 : -1;

      if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
      return 0;
    });
  }

  return filtered;
};


  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      const fileType = file.name.split('.').pop()?.toLowerCase();

      if (fileType === 'csv') {
        reader.onload = function (event) {
          const csvData = event.target?.result;
          if (csvData) {
            const parsedData = Papa.parse(csvData as string, {
              header: true,
              skipEmptyLines: true,
            });
            const filteredData = parsedData.data.filter((row: Record<string, string>) => Object.values(row).some(value => value !== ""));
            insertDataIntoDatabase(filteredData);
          }
        };
        reader.readAsText(file);
      } else if (fileType === 'xlsx' || fileType === 'xls') {
        reader.onload = function (event) {
          const data = new Uint8Array(event.target?.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, raw: false });
          const headers = worksheet[0] as string[];
          const rows = worksheet.slice(1).map((row: unknown, index: number) => {
            if (Array.isArray(row)) {
              let obj: Record<string, string> = {};
              headers.forEach((header, i) => {
                const cellValue = row[i];
                let value = "";

                if (typeof cellValue === "string" && /^\d{1,2}\/\d{1,2}\/\d{2}$/.test(cellValue)) {
                  // Parse MM/DD/YY and convert to DD/MM/YYYY
                  const [month, day, year] = cellValue.split("/");
                  const fullYear = parseInt(year, 10) < 50 ? `20${year}` : `19${year}`; // Adjust to your needs
                  value = `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${fullYear}`;
                } else if (cellValue instanceof Date) {
                  // Format real Date objects
                  const day = String(cellValue.getDate()).padStart(2, '0');
                  const month = String(cellValue.getMonth() + 1).padStart(2, '0');
                  const year = cellValue.getFullYear();
                  value = `${day}/${month}/${year}`;
                } else {
                  value = cellValue != null ? String(cellValue) : "";
                }
                obj[header] = value;
              });

              return obj;
            }
            return {};
          });
          const filteredRows = rows.filter(row => Object.values(row).some(value => value !== ""));

          insertDataIntoDatabase(filteredRows);
        };
        reader.readAsArrayBuffer(file);
      } else {
        setShowUpdateModal(true)
        setModalNewMessage('Unsupported file format. Please upload a CSV or Excel file.');
        // alert('Unsupported file format. Please upload a CSV or Excel file.');
      }
    }
  };

  const insertDataIntoDatabase = (data: any) => {
    setLoadingFileUpload(true);
    authService
      .post('/admin/import_students/', { data, course_id: selectedCourse, batch_id: selectedBatch })
      .then((response) => {
        const editedCount = response.data.edited_count;
        const savedCount = response.data.saved_count;
        const errorCount = response.data.error_count;
        const max_students_reached= response.data.max_students_reached?response.data.max_students_reached :"";
        const editedStudents = response.data.edited_student ? response.data.edited_student.slice(0, response.data.edited_student.length - 2) : "None";
        const savedStudents = response.data.saved_student ? response.data.saved_student.slice(0, response.data.saved_student.length - 2) : "None";
        const errorStudents = response.data.error_student ? response.data.error_student.slice(0, response.data.error_student.length - 2) : "None";
        const newMessage = `Edited Count: ${editedCount}\nSaved Count: ${savedCount}\nError Count: ${errorCount}\nEdited Students: ${editedStudents}\nSaved Students: ${savedStudents}\nError for Students: ${errorStudents} \n ${max_students_reached} `;
        setModalMessage(newMessage);
        setResShowModal(true);
        fetchStudents();
      })
      .catch((error) => {
        console.error('There was an error inserting the data:', error);
      })
      .finally(() => {
        setLoadingFileUpload(false);
      });
  };

  return (
    <>
      {(loadingCourses || loadingColleges || loadingBatches || loadingStudents || loadingEmailCheck || loadingSearchStudent || loadingSaveStudent || loadingDeleteStudent || loadingAllocateStudent || loadingFileUpload) &&
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" role="status" />
        </div>
      }
      <div className="border pt-3 px-2 rounded-2 bg-white my-2 me-2" style={{ height: `calc(100vh - 90px)`, overflowY: "auto" }}>
        <div className="d-flex justify-content-between ">
          <span className="d-flex justify-content-start align-items-center ps-4">
            <label className='me-2'>Course</label>
            <Form.Select className="me-3" style={{ width: "150px" }} onChange={(e) => { setSelectedCourse(e.target.value); setSelectedBatch('') }} value={selectedCourse}>
              {courses.map((course) => (
                <option key={course.course_id} value={course.course_id}>
                  {course.course_name}
                </option>
              ))}
            </Form.Select>
            <label className='me-2'>Batch</label>
            <Form.Select className="me-3" style={{ width: "150px" }} onChange={(e) => setSelectedBatch(e.target.value)} value={selectedBatch}>
              <option value="" key="">Select batch</option>
              {batches.map((batch) => (
                <option key={batch.batch_id} value={batch.batch_id}>
                  {batch.batch_name}
                </option>
              ))}
            </Form.Select>
          </span>
          <div>
            <button
              className="btn"
              onClick={() => {
                setSearchQuery("");
                setSearchError("");
                setShowSearchModal(true);
              }}
            >
              <FaSearch className="me-1" /> Search Student
            </button>
            <button className="btn" onClick={() => { handleModal("new") }}>
              + New Student
            </button>
            <span>
              <input
                type="file"
                accept=".csv,.xls,.xlsx"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
                id="fileUpload"
              />
              <button
                className="btn btn-sm btn-primary"
                onClick={() => document.getElementById('fileUpload')?.click()}
              >
                Import
              </button>
              <a
                href={`${process.env.PUBLIC_URL}/sample.xlsx`}
                download="sample.xlsx"
                className="btn btn-sm btn-secondary ms-2"
              >
                Download Template
              </a>
            </span>
          </div>
        </div>
        <div className="p-4">
        {addStudentError && <p className="text-center text-danger">{addStudentError}</p>}
          <Table className='border-top mt-2'>
            <thead style={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}>
              <tr>
                <td className='fw-normal' >Sl no</td>
                <td className='fw-normal' onClick={() => handleSort('student_id')} >ID 
                     {sortConfig.key === 'student_id' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal' onClick={() => handleSort('student_firstname')}>Name
                     {sortConfig.key === 'student_firstname' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal' onClick={() => handleSort('student_type')}>Student Type
                     {sortConfig.key === 'student_type' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal' onClick={() => handleSort('college')}>College
                     {sortConfig.key === 'college' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal' onClick={() => handleSort('branch')}>Branch
                     {sortConfig.key === 'branch' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal' onClick={() => handleSort('allocate')}>Allocated
                     {sortConfig.key === 'allocate' ? (sortConfig.direction === 'ascending' ? <PiSortAscendingLight size={20} /> : <PiSortDescendingLight size={20} />) : <HiOutlineDotsVertical />}
                </td>
                <td className='fw-normal'>Action</td>
              </tr>
            </thead>
            <tbody>
              {sortedStudents().length > 0 ? (
              sortedStudents().map((student, index) => (
                <tr key={student.student_id}>
                  <td>{index+1}</td>
                  <td>{student.student_id} 
                  </td>
                  <td>{student.student_firstname + " " + student.student_lastname} 
                  </td>
                  <td>{student.student_type}
                  </td>
                  <td>{student.college}
                  </td>
                  <td>{student.branch}
                  </td>
                  <td role="button" onClick={async () => {
                    try {
                      setLoadingAllocateStudent(true);
                      await authService.post("/admin/allocate_student/", { student_id: student.student_id });
                      fetchStudents();
                    } catch (error) {
                      console.error("Error allocating student:", error);
                    } finally {
                      setLoadingAllocateStudent(false);
                    }
                  }}>{student.allocate ? "Yes" : "No"}</td>
                  <td>
                    <FaEdit className="fs-6 me-2" role="button" title="Edit" onClick={() => { handleModal("edit", student) }} style={{ cursor: "pointer" }} />
                    <FaTrash className="fs-6 me-2" role="button" title="Delete" onClick={() => handleDelete(student)} style={{ cursor: "pointer" }} />
                  </td>
                </tr>
              ))):( <td></td>
              )
            }
            </tbody>
          </Table>
        </div>
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete the student: <strong>{selectedStudent?.student_firstname + " " + selectedStudent?.student_lastname}</strong>?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              No
            </Button>
            <Button variant="danger" onClick={confirmDelete} disabled={loadingDeleteStudent}>
              {loadingDeleteStudent ? <Spinner animation="border" size="sm" /> : "Yes, Delete"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showSearchModal} onHide={() => setShowSearchModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Search Student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {searchError && <p className="text-danger">{searchError}</p>}
            <Form.Group controlId="formSearchStudent">
              <Form.Label>Student ID, Email, or Mobile</Form.Label>
              <Form.Control
                type="text"
                value={searchQuery}
                placeholder="e.g. 25EABCXIS001"
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearchStudent();
                  }
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSearchModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSearchStudent} disabled={loadingSearchStudent}>
              {loadingSearchStudent ? <Spinner animation="border" size="sm" /> : "Search"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <p className="text-danger">{error}</p>}
            <Form.Group controlId="formStudentEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEmailModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleEmailSubmit} disabled={loadingEmailCheck}>
              {loadingEmailCheck ? <Spinner animation="border" size="sm" /> : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' backdrop="static" aria-labelledby="contained-modal-title-vcenter example-modal-sizes-title-lg">
          <Modal.Header closeButton>
            <Modal.Title>{modalType === "new" ? "Add New Student" : "Edit Student"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='pt-0'>
            {error && <p className="text-danger">{error}</p>}
            {isDeletedStudentRecord && (
              <p className="text-warning mb-2">
                This student was deleted earlier. Please review and update the details before saving.
              </p>
            )}
            {batchMoveNotice && (
              <p className="text-warning mb-2">{batchMoveNotice}</p>
            )}
            <Form>
              <div className="row">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentCourse" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Course</Form.Label>
                    <Form.Select style={{ width: "50%" }} onChange={(e) => setFormData({ ...formData, course_id: e.target.value })} value={formData.course_id}>
                      {modalCourses.map((course) => (
                        <option key={course.course_id} value={course.course_id}>
                          {course.course_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentBatch" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Batch</Form.Label>
                    <Form.Select style={{ width: "50%" }} onChange={(e) => setFormData({ ...formData, batch_id: e.target.value })} value={formData.batch_id}>
                      {modalBatches.map((batch) => (
                        <option key={batch.batch_id} value={batch.batch_id}>
                          {batch.batch_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <div className="row  ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentFirstName" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*First Name</Form.Label>
                    <Form.Control
                      type="text" style={{ width: "50%" }}
                      name="student_firstname"
                      required
                      value={formData.student_firstname}
                      onChange={(e) => setFormData({ ...formData, student_firstname: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentLastName" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Last Name</Form.Label>
                    <Form.Control
                      type="text" style={{ width: "50%" }}
                      name="student_lastname"
                      value={formData.student_lastname}
                      onChange={(e) => setFormData({ ...formData, student_lastname: e.target.value })}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentGender" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Gender</Form.Label>
                    <Form.Select style={{ width: "50%" }} onChange={(e) => setFormData({ ...formData, student_gender: e.target.value })} value={formData.student_gender}>
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentMail" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Email</Form.Label>
                    <Form.Control style={{ width: "50%" }}
                      type="email"
                      name="student_email"
                      value={formData.student_email}
                      onChange={(e) => setFormData({ ...formData, student_email: e.target.value })}
                      // disabled={modalType === "edit"}
                      disabled={true}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentPhone" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Mobile</Form.Label>
                    <Form.Control
                      style={{ width: "50%" }}
                      type="number"
                      name="phone"
                      maxLength={10}
                      value={formData.phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({ ...formData, phone: value });
                        }
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentDOB" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      style={{ width: "50%" }}
                      name="student_dob"
                      value={formData.student_dob}
                      onChange={(e) => setFormData({ ...formData, student_dob: e.target.value })}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentCountry" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      style={{ width: "50%" }}
                      type="text"
                      name="student_country"
                      value={formData.student_country}
                      onChange={(e) => setFormData({ ...formData, student_country: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentState" className="d-flex align-items-center justify-content-between">
                    <Form.Label>State</Form.Label>
                    <Form.Control style={{ width: "50%" }}
                      type="text"
                      name="student_state"
                      value={formData.student_state}
                      onChange={(e) => setFormData({ ...formData, student_state: e.target.value })}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentCity" className="d-flex align-items-center justify-content-between">
                    <Form.Label>City</Form.Label>
                    <Form.Control style={{ width: "50%" }}
                      type="text"
                      name="student_city"
                      value={formData.student_city}
                      onChange={(e) => setFormData({ ...formData, student_city: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentAddress" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      style={{ width: "50%" }}
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentPinCode" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Pin Code</Form.Label>
                    <Form.Control
                      style={{ width: "50%" }}
                      type="text"
                      name="student_pincode"
                      value={formData.student_pincode}
                      onChange={(e) => setFormData({ ...formData, student_pincode: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentAltPhone" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Alt Mobile</Form.Label>
                    <Form.Control
                      type="number"
                      style={{ width: "50%" }}
                      name="student_alt_phone"
                      maxLength={10}
                      value={formData.student_alt_phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({ ...formData, student_alt_phone: value });
                        }
                      }}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentQualification" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Qualification</Form.Label>
                    <Form.Control
                      style={{ width: "50%" }}
                      type="text"
                      name="student_qualification"
                      value={formData.student_qualification}
                      onChange={(e) => setFormData({ ...formData, student_qualification: e.target.value })}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentCollege" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*College</Form.Label>
                    <Form.Select style={{ width: "50%" }} onChange={(e) => { setSelectedCollege(e.target.value); setFormData({ ...formData, college: e.target.value }) }} value={selectedCollege}>
                      <option value="">Select College</option>
                      {colleges.map((college) => (
                        <option key={college.college_id} value={college.college_code}>
                          {college.college_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentBranch" className="d-flex align-items-center justify-content-between">
                    <Form.Label>*Branch</Form.Label>
                    <Form.Select style={{ width: "50%" }} onChange={(e) => setFormData({ ...formData, branch: e.target.value })} value={formData.branch}>
                      <option value="">Select Branch</option>
                      {branches.map((branch) => (
                        <option key={branch.branch_id} value={branch.branch_name}>
                          {branch.branch_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentType" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Student Type</Form.Label>
                    <Form.Select
                      style={{ width: "50%" }}
                      name="student_type"
                      value={formData.student_type}
                      onChange={(e) => setFormData({ ...formData, student_type: e.target.value })}
                    >
                      <option value="Swapnodaya">Swapnodaya</option>
                      <option value="Exskilence">Exskilence</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <div className="row ">
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentIsActive" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Is Active</Form.Label>
                    <div className="d-flex justify-content-evenly" style={{ width: "50%" }}>
                      <Form.Check
                        type="radio"
                        id="isActiveYes"
                        label="Yes"
                        name="isActive"
                        value="true"
                        checked={formData.isActive === true}
                        onChange={(e) => setFormData({ ...formData, isActive: true })}
                      />
                      <Form.Check
                        type="radio"
                        id="isActiveNo"
                        label="No"
                        name="isActive"
                        value="false"
                        checked={formData.isActive === false}
                        onChange={(e) => setFormData({ ...formData, isActive: false })}
                      />
                    </div>
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6  mt-3">
                  <Form.Group controlId="formStudentAllocate" className="d-flex align-items-center justify-content-between">
                    <Form.Label>Allocate</Form.Label>
                    <div className="d-flex justify-content-evenly" style={{ width: "50%" }}>
                      <Form.Check
                        type="radio"
                        id="AllocateYes"
                        label="Yes"
                        name="Allocate"
                        value="true"
                        checked={formData.allocate === true}
                        onChange={(e) => setFormData({ ...formData, allocate: true })}
                      />
                      <Form.Check
                        type="radio"
                        id="AllocateNo"
                        label="No"
                        name="Allocate"
                        value="false"
                        checked={formData.allocate === false}
                        onChange={(e) => setFormData({ ...formData, allocate: false })}
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave} disabled={loadingSaveStudent}>
              {loadingSaveStudent ? <Spinner animation="border" size="sm" /> : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showResModal} onHide={() => setResShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Response Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <pre>{modalMessage}</pre>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setResShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalNewMessage}</Modal.Body>
            </Modal>

        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{successMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default Student;
